import type { RouteLocationNormalized } from 'vue-router'

import { keys } from '@/app/i18n'
import type { BreadcrumbItem } from '@/app/router/meta'

import { findTab } from './registry'

/** "Settings" → the Configuration tab of the current software (NEW-2: legacy linked a path no route matched). */
export const settingsCrumb: BreadcrumbItem = {
  text: keys.t('settings.shell.title.settings'),
  to: { name: 'settings', params: { tab: 'configuration' } },
}

/**
 * The breadcrumb of a settings location: "Settings" › the tab's label. Called on entry (`beforeEnter`) and on every tab
 * change (`onBeforeRouteUpdate` of the view): the guard's location becomes the current route, so the layout's
 * breadcrumb shows it. The record's array is replaced, never mutated.
 */
export function setTabCrumb(to: RouteLocationNormalized): void {
  const tab = findTab(to.params.tab)
  to.meta.breadcrumb = tab ? [settingsCrumb, { text: tab.label, active: true }] : [settingsCrumb]
}
